<template>
    <div v-shortkey="['esc']" @shortkey="clearFilters()" class="filters" :class="{'filters--open': isOpen}">
        <transition name="fade">
            <div v-if="isOpen" class="filters__overlay overlay" @click="close"></div>
        </transition>
        <span @click="toggle" class="filters__handle">
            <span v-if="hasFilters" class="filters__count">{{ filtersCount }}</span>
            <icon type="filter" size="24" />
        </span>
        <aside @click.stop class="filters__wrapper">
            <header class="filters__header">
                <h3 class="filters__title">Filters</h3>
                <a v-if="hasFilters" href="#" @click.prevent="clearFilters()" class="lc-clear notifications__action">Clear all</a>
                <button @click="close" class="icon-button filters__close">
                    <icon type="close" color="bluegray" size="18" />
                </button>
            </header>

            <div class="filters__group">
                <section class="filters__list">
                    <p class="filters__subtitle">Filter by label</p>
                    <ul class="filters__items">
                        <li @click="toggleFilter('labels', label.id)" class="filters__item" :class="{ 'filters__item--selected': hasLabelFilter(label) }" :key="index" v-for="(label, index) in labels">
                            <span class="label label--option" :class="{[`label--${label.color}`]: true}"></span>
                            <span class="filters__name">{{ label.name }}</span>
                        </li>
                    </ul>
                </section>

                <section class="filters__list">
                    <p class="filters__subtitle">Filter by user</p>
                    <ul class="filters__items">
                        <li @click="toggleFilter('users', user.id)" class="filters__item" :class="{ 'filters__item--selected': hasUserFilter(user) }" :key="user.id" v-for="user in activeMembers">
                            <avatar :user="user" />
                            <span class="filters__name">{{ user.display_name }}</span>
                        </li>
                    </ul>
                </section>
            </div>
        </aside>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import Toggleable from '../../mixins/toggle'
import Avatar from '../Global/Avatar'
import Icon from '../Global/Icon'

export default {
    mixins: [Toggleable],

    methods: {
        toggleFilter (filter, value) {
            this.$store.dispatch('channel/toggleFilter', { filter, value })
        },

        clearFilters () {
            this.$store.dispatch('channel/clearFilters')
        },

        hasLabelFilter (label) {
            return this.filters.labels.includes(label.id)
        },

        hasUserFilter (user) {
            return this.filters.users.includes(user.id)
        }
    },

    computed: {
        ...mapState('channel', ['filters', 'labels']),
        ...mapGetters('channel', ['activeMembers', 'filtersCount']),

        hasFilters () {
            return this.filtersCount > 0
        }
    },

    components: {
        Avatar,
        Icon
    }
}
</script>
